'use client';
import { useSideNavOpen } from '@/store';
import React, { useEffect, useState } from 'react';

const SectionDivider = ({ hideOnMobile = false }) => {
	const sideNavOpen = useSideNavOpen();
	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (hideOnMobile && !sideNavOpen && isMounted) return null;

	return (
		<hr
			className={`   border-powder-blue  

            ${sideNavOpen && isMounted ? 'w-[calc(100%-20px)]' : 'w-full'}
              mx-auto my-2.5`}
		/>
	);
};

export default SectionDivider;
